import {USER_UPDATE_STEP_DOWN, RECEIVE_ALL_USERS, UPDATE_USER, UPDATE_USER_NOTIFICATIONS, UPDATE_USER_IMAGE, RECEIVE_USER_NOTIFICATIONS,VERIFY_SUPERVISOR} from '../actions/user_actions';
var _ = require('lodash')
const users_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);
    let updatedUserInfo = _.cloneDeep(oldState)

    switch (action.type) {
        case RECEIVE_ALL_USERS:        
            const users = _.mapKeys(action.users, "_id")
            let updatedUsers = {...oldState, ...users}
            return updatedUsers
        case UPDATE_USER:
            updatedUserInfo[action.user._id] = action.user
            return updatedUserInfo
        case UPDATE_USER_NOTIFICATIONS:
            updatedUserInfo[action.user._id] = action.user 
            return updatedUserInfo
        case RECEIVE_USER_NOTIFICATIONS: 
            if (updatedUserInfo[action.userId]) {
                updatedUserInfo[action.userId].notifications = action.notifications
            } 
            return updatedUserInfo
        case UPDATE_USER_IMAGE:
            let user = updatedUserInfo[action.user.id];
            if (user) {
                user.image = action.user.image;
                updatedUserInfo[action.user.id] = user;
            } else {
                console.error(`User with id ${action.user.id} not found in updatedUserInfo`);
            }
            return updatedUserInfo;
        case VERIFY_SUPERVISOR:
           // updatedUserInfo[action.user._id] = {verifySupervisor: action.user}
            return {
                ...updatedUserInfo,
                VERIFY_SUPERVISOR: action.user.data
            }
        case USER_UPDATE_STEP_DOWN:
            updatedUserInfo[action.user._id] = action.user
            return updatedUserInfo
       

        default:
            return oldState;
    }
};

export default users_reducer;